import { createAsyncThunk } from '@reduxjs/toolkit';
import { _billingUrls } from '@custom/Utils/constants/apiUrls';

interface GetPackageParams {
  search?: string;
  page?: number;
  limit?: number;
}

const getPackage = createAsyncThunk(
  'getPackage',
  async ({ search = '', page = 1, limit = 30 }: GetPackageParams) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');

    const params = new URLSearchParams();
    if (search) params.append('search', search);
    params.append('page', String(page));
    params.append('limit', String(limit));

    const url = `${_billingUrls.get}?${params.toString()}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch billing package data');
    }
    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
});

export default getPackage;
